import React from 'react';
import Layout from './layout';
import Masthead from '@components/masthead/masthead';
import SectionLayout from './section-layout';
import vars from '@variables';
import { H2Atom, PAtom } from '@atoms/text-atoms/text-atoms';
import { UnorderedListAtom } from '@atoms/list-atoms/list-atoms';
import { ErrorLayoutProps } from './error-layout.types';

const ErrorLayout: React.FC<ErrorLayoutProps> = ({ footerData, errors }) => {
  const errorMessage = () => {
    if (process.env.GATSBY_PREVIEW) {
      return (
        <>
          <H2Atom>Page preview failed</H2Atom>
          {Array.isArray(errors) &&
            errors.map((error, index) => (
              <div key={index}>
                <PAtom>
                  {`The ${error.pageTypeLabel || 'page'} ${
                    error.contentful_id && `(id: ${error.contentful_id})`
                  } you are trying to preview cannot render. This is due to
                the following missing fields:`}
                </PAtom>
                <UnorderedListAtom>
                  {error.missingRequiredFields &&
                    error.missingRequiredFields.map(
                      (missingRequiredField, index) => (
                        <li
                          key={`${missingRequiredField.slice(0, 3)}-${index}`}
                        >
                          {missingRequiredField}
                        </li>
                      )
                    )}
                </UnorderedListAtom>
              </div>
            ))}
          <PAtom>
            Please populate the missing fields in order to preview this page!
          </PAtom>
        </>
      );
    } else {
      return (
        <>
          <H2Atom>This page has failed to render</H2Atom>
          <PAtom>
            The system has failed to retrieve the required data to render this
            page. Our developers have been alerted and are working to resolve
            the issue. Thank you for your patience!
          </PAtom>
        </>
      );
    }
  };

  return (
    <Layout footerData={footerData}>
      <Masthead
        title="Oops... something went wrong"
        hasSecondaryNav={false}
        imageSrc={vars.defaultFlipCardPlaceholder}
        gatsbyImageSrc={null}
        format="png"
        postDate="January 11, 2022"
        linkColorLight={false}
        pageColour={vars.coreDarkGrey}
      />
      <SectionLayout displaySeparator={false}>{errorMessage()}</SectionLayout>
    </Layout>
  );
};

export default ErrorLayout;
